import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedComics from "./components/FeaturedComics";
import LatestUpdates from "./components/LatestUpdates";
import PopularComics from "./components/PopularComics";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "土豪漫画网",
    url: window.location.origin,
    description:
      "土豪漫画网提供韩漫在线免费服务，支持韩漫全集下拉式阅读和韩国漫画大全，让您轻松浏览各种作品，无需下载即可享受沉浸式阅读乐趣。",
    potentialAction: {
      "@type": "SearchAction",
      target: `${window.location.origin}/category/all?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "土豪漫画网",
    url: window.location.origin,
    description:
      "土豪漫画网 - 韩漫在线免费阅读平台，提供韩漫全集下拉式阅读，收录韩国漫画大全。",
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <PopularComics />
        <LatestUpdates />
      </main>
    </>
  );
}